<template>
  <div>
    <!--
    <input
      v-if="editing || !hasContent"
      key=""
      :value="value"
      :type="field.type"
      :required="field.required"
      :placeholder="field.placeholder"
      :name="field.name"
      @focus="editing = true"
      @blur="editing = false"
      @input="update($event.target.value)"
    >
    <span
      v-else
      class="owal token input container"
      @click="editing = true"
    >
      <span
        v-for="(string, index) in this.substrings"
        :key="string"
      >
        <span
          class="ui label"
          :tabindex="index"
          @click="editing = true"
          @keyup.enter="editing = true"
          @keyup.space="editing = true"
          @keyup.delete="editing = true"
        >
          {{ string }}
        </span>
      </span>
    </span>
    <div class="ui popup">
      <div class="content">
        Fill this out later.
      </div>
    </div>
  -->
  </div>
</template>

<script>
import OwalAutosizingTextInput from './OwalAutosizingTextInput'
// import matches from '@/libraries/util/regex'

export default {
  name: 'OwalTokenInput',
  components: { OwalAutosizingTextInput }, // eslint-disable-line
  props: {
    field: {
      required: true,
      type: Object,
    },
    value: {
      default: undefined,
      type: String,
      required: false,
    },
    placeholder: {
      default: '',
      type: String,
      required: false,
    },
    tokenizers: {
      type: Array,
      default: function () {
        return []
      },
      required: false, // If no tokenizers, behaves like regular input.
    },
  },
  data () {
    return {
      text: undefined,
      editing: false,
    }
  },
  computed: {
    substrings: function () {
      if (!this.text) {
        return ['']
      }
      return this.substringsFromCompositeString(this.text)
    },
    hasContent: function () {
      const hasContent = this.text && this.text.length > 0
      return hasContent
    },
  },
  mounted: function () {
    this.update(this.value)
  },
  methods: {
    prepareForInputAfterFocus: function () {
      if (!this.editing) {
        this.setActiveFieldIndex(this.substrings.length - 1)
      }
    },
    update: function (value) {
      if (!value) {
        console.log('Undefined value, returning.')
        return
      }
      /*
        The old way to tokenize on the fly, for posterity.
        1. Capture state
        2. Replace current substring
        3. Rebuild full string
        4. Re-tokenize
        5. Capture new state
        6. Compute changes
        7. Update UI
      */

      this.text = value
      this.$emit('input', value)
    },
    tokensFromInput: function (string) {
    },
    substringsFromCompositeString: function (string) {
      if (!string) {
        // console.log('String is undefined, returning an empty array.')
        return ['']
      }
      // console.log(`Substrings for string: ${string}`)
      const substrings = string.trim().split(' ')
      // console.log(`Substrings: ${JSON.stringify(substrings)}`)
      return substrings
    },
    state: function () {
      return {
        tokenCount: this.substrings.length,
        currentIndex: this.currentIndex,
        stringLength: this.compositeStringFromSubstrings(),
      }
    },
    changesBetweenStates: function (oldState, newState) {
      return {
        tokenAdded: oldState.tokenCount < newState.tokenCount,
        tokenRemoved: oldState.tokenCount > newState.tokenCount,
      }
    },
    handleBlur: function (event) {
      this.editing = false
    },
    handleClick: function (e) {
      this.prepareForInputAfterFocus()
    },
    handleFocus: function () {
      this.prepareForInputAfterFocus()
    },
    setActiveFieldIndex: function (proposedIndex) {
      // console.log(`Proposed index ${proposedIndex} `)
      this.editing = true
      const maximumIndex = this.substrings.length - 1
      this.activeFieldIndex = Math.min(Math.max(0, proposedIndex), maximumIndex)
      // console.log(`Set index to ${this.activeFieldIndex}`)
    },
  },
}
</script>

<style scoped>
.owal.token.input.container {
  padding: 0.68em 1em;
  border-radius: 5px;
  border: 1px solid rgba(34, 36, 28, 0.14902);
  display: flex;
  align-items: center;
}

.owal.token.input.ui.label {
  flex-grow: 1;
  margin-left: 15px;
}

.owal.token.input.substring {
  display: flex;
  align-items: center;
}

</style>
